import { render } from "./Megaprint.vue?vue&type=template&id=2929fa2e"
import script from "./Megaprint.vue?vue&type=script&lang=js"
export * from "./Megaprint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__